import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'

import {toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Logo from '../components/logos/logo'

const api = require('../apis/login');
const util = require('../utils/index');

import {
  MDBBtn,
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardBody,
  MDBInput,
  MDBValidation,
  MDBValidationItem,
  
}
from 'mdb-react-ui-kit';

function Login() {
  const navigate = useNavigate();
  
  const [formValue, setFormValue] = useState({
    usuario: '',
    senha: ''
  });

  const handleSubmit = async (values) => {
    try{
      values.preventDefault();
      util.isSubmitting()
      const result = await api.loginApi(formValue);
      
      result ? toast.success("Logado com sucesso!") && navigate("/home") : null;
      util.isSubmitting()
    }catch(e) {
      toast.error(e)
    }
  }

  const onChange = (e) => {
    setFormValue({ ...formValue, [e.target.name]: e.target.value });
  };

  const onBlur = (e) => {
    setFormValue({ ...formValue, [e.target.name]: e.target.value });
  };



  return (
    <MDBContainer fluid className=' background-radial-gradient' style={{
      height:"100vh", display:"flex", justifyContent:"center", alignContent:"center"
      
      }}>
      <MDBRow center className='w-100 d-flex align-items-center justify-content-center'>

        <MDBCol size='12' className='h-100 d-flex align-items-center justify-content-center'>

          <MDBCard className='bg-dark text-white w-100' style={{borderRadius: '1rem', maxWidth: '400px'}}>
              <MDBCardBody className='d-flex flex-column align-items-center'>

                <Logo/>
                <h4 className="text-white-100 my-4">Login</h4>
                  <MDBValidation className='w-100' onSubmit={handleSubmit}>
                    <MDBValidationItem feedback='Por favor digite seu usuario!' invalid>
                      <MDBInput 
                        wrapperClass='mb-5 w-100' 
                        labelClass='text-white' 
                        label='Usuario' 
                        name='usuario'
                        id='formControText' 
                        type='text' 
                        size="lg"
                        value={formValue.usuario}
                        onChange={onChange}
                        onBlur={onBlur} 
                        required
                        style={{color:"white"}}/>
                    </MDBValidationItem >
                    <MDBValidationItem feedback='Por favor digite uma senha válida!' invalid>
                      <MDBInput 
                        wrapperClass='mb-5 w-100' 
                        labelClass='text-white' 
                        label='Senha' id='formControPassword' 
                        type='password' 
                        size="lg" 
                        style={{color:"white"}}
                        name='senha'
                        value={formValue.senha}
                        onChange={onChange}
                        onBlur={onBlur} 
                        required
                        minLength={3}
                        
                        />
                    </MDBValidationItem>
                      <MDBBtn 
                        outline 
                        className='px-5 w-100' 
                        color='white' 
                        size='lg'
                        type='submit'   
                        id='submitForm'  
                        disabled={formValue.senha.length < 3 || formValue.usuario.length < 1}                 
                        >
                        
                        Login
                      </MDBBtn>
                  </MDBValidation>
              </MDBCardBody>
          </MDBCard>


        </MDBCol>

      </MDBRow>

    </MDBContainer>
  );
}

export default Login;